import { CheckoutShippingMethodLocation } from '@/types/checkout/CheckoutShippingMethodLocation';

import CheckoutStep, { CheckoutStepModelProps } from '@/models/checkout/CheckoutStep';

// Step Data Props
export interface StepShippingMethodDataProps {
	shippingMethods: CheckoutShippingMethodLocation[];
}

// JS Model Props
export interface StepShippingMethodModelProps extends CheckoutStepModelProps {
	data: Partial<StepShippingMethodDataProps>;
}

// API Response Props
// No API props; data stored locally only

// Constructor Props
export type StepShippingMethodCtorProps = StepShippingMethodModelProps;

export default class StepShippingMethod extends CheckoutStep {

	shippingMethods: CheckoutShippingMethodLocation[];

	constructor(props: StepShippingMethodCtorProps) {
		
		const mappedProps = StepShippingMethod.mapStepDataToModel(props);

		super(props);

		this.shippingMethods = mappedProps.shippingMethods;
	}

	// Explicitly map API response to the internal model format
	private static mapStepDataToModel(props: StepShippingMethodCtorProps): StepShippingMethodDataProps {
				
		return {
			shippingMethods: props.data?.shippingMethods ?? [],
		};
	}
}